import type {PaddingProps} from "@/styles/padding.types";

import theme from "@/styles/theme";
import {css} from "styled-components";

const paddings = {
    none: 0,
    x2small:theme.padding.xsmall,
    xsmall: theme.padding.xsmall,
    small: theme.padding.small,
    default: theme.padding.default,
    large: theme.padding.large,
    xlarge: theme.padding.xlarge,
    x2large: theme.padding.x2large,
    x3large: theme.padding.x3large,
    x4large: theme.padding.x4large,
    x5large: theme.padding.x5large,
    x6large: theme.padding.x6large,
    x7large: theme.padding.x7large
};

export const padding =
    ({
         padding,
         paddingVertical,
         paddingHorizontal,
         paddingTop,
         paddingRight,
         paddingBottom,
         paddingLeft
     }: PaddingProps) => {
        return  css`
          ${padding && css`padding: ${paddings[padding]}px;`}
          ${paddingVertical && css`padding-top: ${paddings[paddingVertical]}px;padding-bottom: ${paddings[paddingVertical]}px;`}
          ${paddingHorizontal && css`padding-left: ${paddings[paddingHorizontal]}px;padding-right: ${paddings[paddingHorizontal]}px;`}
          ${paddingTop && css`padding-top: ${paddings[paddingTop]}px;`}
          ${paddingRight && css`padding-right: ${paddings[paddingRight]}px;`}
          ${paddingBottom && css`padding-bottom: ${paddings[paddingBottom]}px;`}
          ${paddingLeft && css`padding-left: ${paddings[paddingLeft]}px;`}
        `;
    };
